 <ng-container *ngFor="let i of getImgUrls()">

     <wep-image class="wep-ag-grid-cell-renderer-img__image"
     [css]="'mh20 mw20'"
     (click)="onClick()"
     [src]="i">
    </wep-image>
</ng-container>